import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { EntityTypes } from 'context/entityContext';

import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

export interface IBreakdownURLArgs {
  countryIds?: string[];
  download?: boolean;
  entityIds: string[];
  sfvEntityType: EntityTypes;
  region?: string;
  platform?: number;
  compareMode?: string;
  metricType?: string;
  contentType?: string;
  customRegion?: string | string[];
}

export default function getBreakdownURL(options: IBreakdownURLArgs): string {
  const {
    countryIds,
    entityIds,
    metricType,
    sfvEntityType,
    region,
    platform,
    contentType,
    compareMode,
    customRegion,
    download,
  } = options;

  const apiEntityType = entityTypeToApiType(sfvEntityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter: platform,
    metricType,
    download,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
    contentType,
  });

  return `/api/shortFormVideo/breakdown/${apiEntityType}/${entityIds}?${params}`;
}
